import { BsPatchCheckFill } from 'react-icons/bs';

import { Badge, BadgeProps, Tooltip } from '@mantine/core';

export const VerifiedBadge = ({
    withTooltip,
    companyName,
    size = 'sm',
    compact,
    compactSize = 14,
    ...props
}: BadgeProps & {
    withTooltip?: boolean;
    companyName: string;
    compact?: boolean;
    compactSize?: number;
}) => {
    return (
        <Tooltip
            label={`This profile is owned, maintained and verified by ${companyName}`}
            disabled={!withTooltip}
            offset={10}
        >
            {compact ? (
                <BsPatchCheckFill size={compactSize} color="var(--mantine-color-primary-4)" {...(props as any)} />
            ) : (
                <Badge size={size} radius={99} color="primary.4" leftSection={<BsPatchCheckFill />} {...props}>
                    Verified
                </Badge>
            )}
        </Tooltip>
    );
};
